<template>
    <div  data-step="3" data-intro="待办、已办、邮件快捷入口~">
      <el-row :gutter="20" class="zq">
        <el-col :span="3" style="width:25%;text-align: center;" class="flow_item">
          <div @click="handleRowClick('/fvue/v-flow/v-haiyaTodo?curr=todo')" style="padding-top: 8px;">
            <div style="vertical-align: middle;display: inline-block;"><img src="/fvue/img/daiban20221230.png" ></div>
            <div style="display: inline-block;vertical-align: middle; ">
              <div style="padding-bottom: 8px;"> 
                <span is-dot class="flow_item__count" style="font-size:24px;font-family:JDZhengHT-Regular, JDZhengHT;font-weight:400;color:#E70D0D;;">
                  {{myTaks}}
                </span>
                <el-badge is-dot class="item" v-if="myTaks != '0'" style="width: 6px;height: 6px;bottom: 16px;right: 8px;">

                </el-badge>
              </div>
                <div style="line-height:22px;height:22px;"> 
                  <span class="flow_item__text" style="font-size:14px;font-family:PingFang SC-Regular, PingFang SC;font-weight:400;color:#52535E;">
                  待办事项
                  </span>
                </div>
            </div>
          </div>

        </el-col>
        <el-col :span="3" style="width:25%;text-align: center;" class="flow_item">
          <div @click="handleRowClick('/fvue/v-flow/v-haiyaDone')" style="padding-top: 8px;">
            <div style="vertical-align: middle;display: inline-block;"><img src="/fvue/img/yiban20221230.png" ></div>
            <div style="display: inline-block;vertical-align: middle;">
              <div style="padding-bottom: 8px;"> 
                <span class="flow_item__count" style="font-size:24px;font-family:JDZhengHT-Regular, JDZhengHT;font-weight:400;color:#292B44;">{{myAlready}}</span>
              </div>
              <div style="line-height:22px;height:22px;"> <span class="flow_item__text" style="font-size:14px;font-family:PingFang SC-Regular, PingFang SC;font-weight:400;color:#52535E;">已办事项</span></div>
            </div>
          </div>

        </el-col>
        <el-col :span="3" style="width:25%;text-align: center;" class="flow_item">
          <div @click="handleRowClick('/fvue/v-flow/v-request')" style="padding-top: 8px;">
            <div style="vertical-align: middle;display: inline-block;"><img src="/fvue/img/chuanyue20221230.png" ></div>
            <div  style="display: inline-block;vertical-align: middle;">
              <div style="padding-bottom: 8px;"> 
                <span is-dot class="flow_item__count" style="font-size:24px;font-family:JDZhengHT-Regular, JDZhengHT;font-weight:400;color:#292B44;">
                {{myRequest}}
                </span>
                <el-badge is-dot class="item" v-if="myRequest != '0'"  style="width: 6px;height: 6px;bottom: 16px;right: 8px;">

                </el-badge>
              </div>
              <div style="line-height:22px;height:22px;"> <span  class="flow_item__text" style="font-size:14px;font-family:PingFang SC-Regular, PingFang SC;font-weight:400;color:#52535E;">我的请求</span></div>
            </div>
          </div>

        </el-col>

        <el-col :span="3" style="width:25%;text-align: center;" class="flow_item">
          <div  @click="handleRowClick('/fvue/v-flow/v-draft')" style="padding-top: 8px;">
            <div style="vertical-align: middle;display: inline-block;"><img src="/fvue/img/youxiang20221230.png" ></div>
            <div  style="padding-left:6px;display: inline-block;vertical-align: middle;">
              <div style="padding-bottom: 8px;"> 
                <span is-dot class="flow_item__count" style="font-size:24px;font-family:JDZhengHT-Regular, JDZhengHT;font-weight:400;color:#292B44;">
                {{myDraft}}
                </span>
                <el-badge is-dot class="item" v-if="myDraft != '0'" style="width: 6px;height: 6px;bottom: 16px;right: 8px;">

                </el-badge>
              </div>
              <div style="line-height:22px;height:22px;"> <span  class="flow_item__text" style="font-size:14px;font-family:PingFang SC-Regular, PingFang SC;font-weight:400;color:#52535E;">我的草稿</span></div>
            </div>
          </div>

        </el-col>
      </el-row>
    </div>
</template>

<script>
import utils from "@/utils.js";
    export default {
        data() {
            return {
                data:{},
                account:'',
                fullname:'',
                myTaks:0,
                myNotice:{dataText:0,dataContent:0},
                myAlready:0,
                myEmail:0,
                myRequest:0,
                myDraft:0
            }
        },
        mounted:function(){//加载事件
            this.initData();//加载时触发数据填充
        },
        methods:{
            //下面是函数
            initData(){
                this.$http.get(`${window.context.portal}/runtime/instance/v1/getDefaultInfoMap`).then((resp) => {debugger;
                    this.myTaks = resp.data.myTaks.dataText;
                    this.myNotice.dataText = resp.data.myNotice.dataText;
                    this.myNotice.dataContent = resp.data.myNotice.dataContent;
                    this.myAlready = resp.data.myAlready.dataText;
                    this.myEmail = resp.data.myEmail.dataText;
                    this.myRequest = resp.data.myRequest.dataText;
                    this.myDraft = resp.data.myDraft.dataText;
                    this.data = resp.data;
                    console.log(resp.data.myTaks);
                });
            },
            handleRowClick(url) {
                let User = JSON.parse(window.sessionStorage.currentUser);
                this.account = User.account;
                this.fullname = User.fullname;
                if(url.startsWith("http://")){
                    let password = window.sessionStorage.getItem("password");
                    window.open(url+"?username="+this.account+"&password="+password,"_blank");
                    return ;
                }debugger;
                window.open(url,"_self");

                // this.$router.push(url);
                // utils.reload();
            },
        }
    }
</script>

<style lang="scss" scoped>
@import "@/assets/css/element-variables.scss";

</style>
